import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'recovery_forgot.title',
  },
  formTitle: {
    id: 'recovery_forgot_password.title',
  },
  formSubTitle: {
    id: 'recovery_forgot_password.sub_title',
  },
  identifiant: {
    id: 'login_page.form.identifiant',
  },
  valid: {
    id: 'recovery_forgot_password.title_button_valid',
  },
  forgotLogin: {
    id: 'recovery_forgot_password.title_button_identifiant',
  },
  requiredField: {
    id: 'required.field',
  },
  loginError: {
    id: 'recovery_forgot_password.login_error',
  },
  modalHeader: {
    id: 'info.modal_header',
  },
  modalContent: {
    id: 'info.modal_content',
  },
  close: {
    id: 'modal.close',
  },
});
